import React, { useEffect, useState } from "react";
import TopBar from "../Components/TopBar";
import "../Style/forums.css";
import TopBarAds from "../Components/TopBarAds";
import FooterBottom from "../Components/FooterBottom";
import axios from "axios";
import { useParams } from "react-router-dom";

function Forums() {
  const [news, setNews] = useState([]);
  const { id } = useParams();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`https://nland.onrender.com/forums/${id}`)
      .then((res) => {
        setLoading(true);
        const data = res.data;
        console.log("dataaaaaaaaaa", data);
        function indexOfLongestString(strings) {
          if (strings.length === 0) {
            return -1; // Return -1 if the array is empty
          }

          let longestIndex = 0; // Assume the first string is the longest initially

          for (let i = 1; i < strings.length; i++) {
            if (strings[i].length > strings[longestIndex].length) {
              longestIndex = i; // Update longestIndex if a longer string is found
            }
          }

          return longestIndex;

        }
        let dat = [];
        for (
          let i = indexOfLongestString([
            data[0].title,
            data[1].title,
            data[2].title,
          ]);
          i < data.length;
          i += 3
        ) {
          dat.push(data[i]);
        }

        setNews(dat);
        console.log(news, dat);

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);

        setLoading(false);
      });

  }, []);
  return (
    <div className="forums">
      <div className="foh_topbar">
        <TopBar />
      </div>
      <div className="forum_head">
        <div className="foh_top">
          {" "}
          {id.charAt(0).toUpperCase() + id.slice(1)} - Nairaland
        </div>
        <div className="foh_mid">
          <a href="">
            Nairaland Forum / Nairaland / General /{" "}
            {id.charAt(0).toUpperCase() + id.slice(1)}
          </a>
        </div>
      </div>
      <div className="foh_ads">
        <TopBarAds />
      </div>
      <div className="foh_pages">
        <b>
          <a href={`/forums/${id}`}>(1)</a>
          <a href={`/forums/${id}/2`}>(2)</a>
          <a href={`/forums/${id}/3`}>(3)</a>
          <a href={`/forums/${id}/4`}>(4)</a>
          <a href={`/forums/${id}/5`}>(5)</a>
          <a href={`/forums/${id}/6`}>(6)</a>
          <a href={`/forums/${id}/7`}>(7)</a>
          <a href={`/forums/${id}/8`}>(8)</a>
          <a href={`/forums/${id}/9`}>(9)</a>
          <a href={`/forums/${id}/10`}>(10)</a>
          <a href={`/forums/${id}/11`}>(11)</a>
        </b>
      </div>
      <div className="foh_news">
        <div className="foh_news-top">Topic: Posts / Views / Updated / New</div>
        <div className="foh_news-mid">
          {loading ? (
            <h2>Loading....</h2>
          ) : (
            news &&
            news.map((res, index) => {
              let title = res.title;
              let url = encodeURIComponent(
                "https://www.nairaland.com" + res.url
              );
              console.log(url);
              return (
                <div>
                  {title.length > 15 && (
                    <a
                      className="ns_mid-news"
                      key={index}
                      href={"/open/" + url}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: title && title }}
                      />
                    </a>
                  )}
                </div>
              );
            })
          )}
        </div>
      </div>
      <div className="foh_pages">
        <b>
          <a href={`/forums/${id}`}>(1)</a>
          <a href={`/forums/${id}/2`}>(2)</a>
          <a href={`/forums/${id}/3`}>(3)</a>
          <a href={`/forums/${id}/4`}>(4)</a>
          <a href={`/forums/${id}/5`}>(5)</a>
          <a href={`/forums/${id}/6`}>(6)</a>
          <a href={`/forums/${id}/7`}>(7)</a>
          <a href={`/forums/${id}/8`}>(8)</a>
          <a href={`/forums/${id}/9`}>(9)</a>
          <a href={`/forums/${id}/10`}>(10)</a>
          <a href={`/forums/${id}/11`}>(11)</a>
        </b>
        <span></span>
      </div>
      <div className="foh_ads">
        <TopBarAds />
      </div>
      <div className="foh_fbottom">
        <FooterBottom />
      </div>
    </div>
  );
}

export default Forums;
